import moment from 'moment';
import { DEFAULT_TIMESTAMP_FORMAT } from '../constants/constants';

export const formatDate = (date) =>
  moment(date).format(DEFAULT_TIMESTAMP_FORMAT);
